import React, { useState } from 'react';
import classes from './CameraTableLayout.module.css';
import tableClasses from '../Table/Table/EventsTable.module.css';
import BasicTable from './Table/Table';
import Pill_Widget from '../UI/Widgets/Pill_Widget';
import Pill_Widget_2 from '../UI/Widgets/Pill_Widget_2';
import { useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { serviceActions } from '../../store/service-Slice';
import useSetCookie from '../hooks/UseSetCookie';
import { deleteLiveViewCamera } from '../../Api Methods/Api';
import { Checkbox } from 'primereact/checkbox';
import { Button } from 'primereact/button';

const CameraTableLayout = ({ data, isloading, groups, filtering, apiData, onRefresh }) => {

  const navigate = useNavigate();
  const dispatch = useDispatch();

  console.log(data);

  const [selectedIds, setSelectedIds] = useState([]);
  const [isUnlinking, setIsUnlinking] = useState(false);

  const allIds = (data ?? []).map(c => c.id);
  const selectAll = allIds.length > 0 && allIds.every(id => selectedIds.includes(id));

  const toggleSelectAll = () => {
    setSelectedIds(selectAll ? [] : allIds);
  };

  const toggleRow = (id) => {
    setSelectedIds(prev =>
      prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]
    );
  };

  const handleUnlink = async () => {
    setIsUnlinking(true);
    for (const id of selectedIds) {
      await deleteLiveViewCamera(apiData, id, dispatch);
    }
    setSelectedIds([]);
    setIsUnlinking(false);
    if (onRefresh) onRefresh();
  };

  const HandleUipiodOnClick = (DeviceUUID) => {
    dispatch(serviceActions.setDeviceUUID(DeviceUUID));
    useSetCookie("DeviceUUID", DeviceUUID, 1);
    navigate("/Dashboard/SiteView/" + DeviceUUID);
  };

  const HandleGroupOnClick = (groupName) => {
    const groupClicked = groups?.find(g => g.name === groupName);
    if (groupClicked) {
      sessionStorage.setItem('groupClicked', groupClicked.name);
      sessionStorage.setItem('groupPath', groupClicked.group_path);
      sessionStorage.setItem('groupClickedID', groupClicked.id);
      navigate("/Dashboard/Groups/GroupSites");
    }
  };

  const m_names = ["January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"];

  function formatDate(date) {
    const day = date.getDate();
    const sup = [1, 21, 31].includes(day) ? "st"
      : [2, 22].includes(day) ? "nd"
      : [3, 23].includes(day) ? "rd" : "th";
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    const h = hours % 12 || 12;
    const m = minutes < 10 ? '0' + minutes : minutes;
    return `${day}${sup} ${m_names[date.getMonth()]} ${date.getFullYear()}, ${h}:${m} ${ampm}`;
  }

  const companyColors = {
    EyeSpyFX: "rgb(100, 149, 237)",
    RESURE: "rgb(75, 0, 130)",
    PARFAS: "rgb(0, 0, 0)",
    PORTAL_SECURITY: "rgb(0, 0, 139)",
    SOLO: "rgb(178, 34, 34)",
    KNOWIO: "rgb(20, 155, 8)",
    CPS: "rgb(8, 155, 121)",
    CSC_SECURITY: "rgb(8, 150, 155)",
    EES: "rgb(94, 8, 155)"
  };

  const tablecolumns = [
    {
      id: 'name',
      header: () => (
        <div className={classes.tableTitleText} style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <Checkbox onChange={toggleSelectAll} checked={selectAll} />
          <h3>Camera name</h3>
        </div>
      ),
      accessorKey: 'name',
      cell: (row) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <Checkbox
            checked={selectedIds.includes(row.row.original.id)}
            onChange={() => toggleRow(row.row.original.id)}
          />
          <div className={classes.tableValueText}>
            {row.row.original.name}
          </div>
        </div>
      ),
    },
    {
      id: 'type',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>Type</h3>
        </div>
      ),
      accessorKey: 'type',
      cell: (row) => {
        let text = '';
        let pillColour = '#6e6e6e';
        switch (row.row.original.type) {
          case 'HIKVISION':
            text = 'Hikvision';
            pillColour = '#616366';
            break;
          case 'DAHUA':
            text = 'Dahua';
            pillColour = '#ee0018';
            break;
          case 'AJAX':
            text = 'AJAX';
            pillColour = '#1a1a1aff';
            break;
          case 'AIBOX':
            text = 'AIBox';
            pillColour = '#00bbf8';
            break;
          default:
            text = row.row.original.type;
        }
        return (
          <div className={classes.tableValueText}>
            <Pill_Widget_2 pillColour={pillColour} text={text} />
          </div>
        );
      },
    },
    {
      id: 'tag',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>Site name</h3>
        </div>
      ),
      accessorKey: 'tag',
      cell: (row) => {
        const uuid = row.row.original.uuid;
        return (
          <div style={{
            maxWidth: '150px',
            overflow: 'hidden',
            whiteSpace: 'normal',
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 2,
          }}>
            <div onClick={() => HandleUipiodOnClick(uuid)} style={{ cursor: 'pointer', width: 'fit-content' }}>
              {row.row.original.tag && row.row.original.tag.trim() !== '' && (
                <Pill_Widget
                  boolean={true}
                  PillColor_IfTrue={"#919191"}
                  PillColor_IfFalse={"#6e6e6e"}
                  text_IfTrue={row.row.original.tag}
                  className={classes.PillHeight}
                />
              )}
            </div>
          </div>
        );
      },
    },
    
    {
      id: 'key',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>Site ID</h3>
        </div>
      ),
      accessorKey: 'key',
      cell: (row) => {
        const uuid = row.row.original.uuid;
        const key = row.row.original.key;
        return (
          <Link
            onClick={() => HandleUipiodOnClick(uuid)}
            to={`/Dashboard/SiteView/${uuid}`}
            className={classes.tableValueTextBold}
          >
            {key}
          </Link>
        );
      },
    },
    {
      id: 'dateAdded',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>Date added</h3>
        </div>
      ),
      accessorKey: 'dateAdded',
      cell: (row) => {
        let dateAdded = formatDate(new Date(row.row.original.dateAdded))
        return (
          <div className={classes.tableValueText}>
            {dateAdded}
          </div>
        )
        
      }
    },
    {
      id: 'group',
      header: () => (
        <div className={classes.tableTitleText}>
          <h3>Group</h3>
        </div>
      ),
      accessorKey: 'groupName',
      cell: (row) => {
        let companyName = row.row.original.groupName;
        if (companyName === "RE:SURE") companyName = "RESURE";
        const color = companyColors[companyName] || "#6e6e6e";

        return (
          <div style={{
            maxWidth: '200px',
            overflow: 'hidden',
            whiteSpace: 'normal',
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 2,
            cursor: 'pointer',
          }} onClick={() => HandleGroupOnClick(row.row.original.groupName)}>
            <Pill_Widget
              boolean={true}
              PillColor_IfTrue={color}
              PillColor_IfFalse={"#626a67"}
              text_IfTrue={row.row.original.groupName}
              className={classes.PillHeight}
            />
          </div>
        );
      },
    },
  ];

  return (
    <div className={classes.table}>
      <div className={classes['tableCardLayoutUI-wrapper']}>
        {selectedIds.length > 0 && (
          <div className={classes.toolbar}>
            <span className={classes.selectedCount}>{selectedIds.length} camera{selectedIds.length !== 1 ? 's' : ''} selected</span>
            <Button
              label={isUnlinking ? 'Unlinking...' : `Unlink ${selectedIds.length} camera${selectedIds.length !== 1 ? 's' : ''}`}
              icon="pi pi-times"
              severity="danger"
              outlined
              disabled={isUnlinking}
              onClick={handleUnlink}
            />
          </div>
        )}
        {isloading ? (
          <div className={classes['skeleton-list']}>
            {[...Array(10)].map((_, i) => (
              <div key={i} className={classes['skeleton-row']}>
                <div className={classes['skeleton-cell']}>
                  <div className={classes['skeleton-bar']} style={{ width: `${100 + (i % 4) * 30}px`, height: '16px' }} />
                </div>
                <div className={classes['skeleton-cell']}>
                  <div className={classes['skeleton-bar']} style={{ width: '80px', height: '16px' }} />
                </div>
                <div className={classes['skeleton-cell']}>
                  <div className={classes['skeleton-bar']} style={{ width: '100px', height: '16px' }} />
                </div>
                <div className={classes['skeleton-cell']}>
                  <div className={classes['skeleton-bar']} style={{ width: `${80 + (i % 3) * 20}px`, height: '16px' }} />
                </div>
                <div className={classes['skeleton-cell']}>
                  <div className={classes['skeleton-bar']} style={{ width: '90px', height: '16px' }} />
                </div>
              </div>
            ))}
          </div>
        ) : (
          <BasicTable
            data={data ?? []}
            columns={tablecolumns}
            filtering={filtering || ""}
            rowClick={false}
            ShowPagination={true}
            PageSize={50}
            paginationOptions={[25, 50, 100]}
            tableClasses={tableClasses}
          />
        )}
      </div>
    </div>
  );
};

export default CameraTableLayout;
